import axios from 'axios';
// const BASE_URL = import.meta.env.VITE_API_BASE_URL;
const BASE_URL = process.env.REACT_APP_API_BASE_URL;;

const axiosInstance= axios.create({
  baseURL: BASE_URL||"http://localhost:3500",  // Replace with your API base URL
  timeout: 10000,  // Timeout after 10 seconds
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor (Add Authorization Token to Headers)
axiosInstance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token'); 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Response Interceptor (Handle global errors or responses)
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      // Handle unauthorized access, possibly redirect to login
      
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
